import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Link,
    List,
    ListItem,
    Paper,
    Stack,
    Typography
} from "@mui/material";
import {useMainContext} from "../constants";
import {ExpandMore} from "@mui/icons-material";

export default function Modified() {

    const { mainVariant, smallVariant, smallerVariant, smallestVariant } = useMainContext();

    return (
        <Box sx={{ maxWidth: 'lg',
            paddingLeft: { xs: "10px", sm: "20px", md: "30px"},
            paddingRight: { xs: "10px", sm: "20px", md: "30px"},
            paddingBottom: { xs: "10px", sm: "20px", md: "30px"},
            marginLeft: "auto", marginRight: "auto" }}>
            <Stack direction="column" spacing={2} sx={{ marginTop: { xs: "10px", sm: "15px", md: "20px"}}}>
                <Typography variant={ smallerVariant } sx={{ fontWeight: "bold"}}>Coed Modified</Typography>
                <Typography variant="body1">
                    The Co-ed Modified program is an excellent starting point for your athlete’s soccer experience.
                    Competing in the WNYCMSL, our teams consistently finish at the top of the league,
                    balancing skill development with a competitive spirit.
                </Typography>
                <List>
                    <ListItem>
                        <Typography variant="body1">
                            <strong>Eligibility:</strong> Boys and girls ages 10–14. Athletes must be 14 or younger as of September 1st of the current season. Physically ready 9-year-olds are considered on a case-by-case basis.
                        </Typography>
                    </ListItem>
                    <ListItem>
                        <Typography variant="body1">
                            <strong>Team Selection:</strong> Players are evaluated during the first two weeks of August and divided into balanced, even teams to ensure fair competition.
                        </Typography>
                    </ListItem>
                    <ListItem>
                        <Typography variant="body1">
                            <strong>Family-Friendly Pairing:</strong> We prioritize placing siblings on the same team and do our best to accommodate carpool requests.
                        </Typography>
                    </ListItem>
                    <ListItem>
                        <Typography variant="body1">
                            <strong>League Play:</strong> Our teams compete in a local co-ed league against other Christian school programs in the area.
                        </Typography>
                    </ListItem>
                </List>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMore/>} data-testid="soccerModifiedSeason">
                        <Typography variant={smallestVariant}>Season</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body1">The Modified season consists of (in addition to the General Schedule):</Typography>
                        <ul>
                            <li>Around 10 WNYCMSL league games in September and October</li>
                            <li>Playoffs and Championship end of October</li>
                            <li>We do our best to have away games on Tuesdays and home games on Thursdays</li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
            </Stack>
        </Box>
    )
}
